import * as React from "react"

import { cn } from "@/lib/utils"
import { FIELD_LOOK } from "@/components/ui/field-look"

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        FIELD_LOOK,
        "flex field-sizing-content min-h-16 py-2",
        className
      )}
      {...props}
    />
  )
}

export { Textarea }
